import React from "react";
import { Box, Button, Container, Grid, Typography } from "@mui/material";

import gitam from "../../../assets/nw/GITAM-logo.jpg";
import cambridge from "../../../assets/nw/download.jpg";
import dravid from "../../../assets/nw/download-5.png";
import vidyashilp from "../../../assets/nw/download-3.png";
import stonehill from "../../../assets/nw/download-4.png";
import aimsrc from "../../../assets/nw/download-1.jpg";
import amity from "../../../assets/nw/Amity.jpg";
import poornaprajna from "../../../assets/nw/download-2.jpg";
import msec from "../../../assets/nw/msec.webp";
import visvesvaraya from "../../../assets/nw/8cfNp55sOTRvSpo6oyqnX7h0yasRzXaFwzrHf2Lz.png";

const EducationLogos = [
  { id: 1, image: gitam, name: "Gitam" },
  { id: 2, image: cambridge, name: "Cambridge" },
  { id: 3, image: dravid, name: "Dravid" },
  { id: 4, image: vidyashilp, name: "Vidyashilp" },
  { id: 5, image: stonehill, name: "Stonehill" },
  { id: 6, image: aimsrc, name: "Aimsrc" },
  { id: 7, image: amity, name: "Amity" },
  { id: 8, image: poornaprajna, name: "Poornaprajna" },
  { id: 9, image: msec, name: "Msec" },
  { id: 10, image: visvesvaraya, name: "Visvesvaraya" },
];

const NeighbourhoodEducation = () => {
  return (
    <Box>
      <Box
        sx={{
          backgroundColor: "#000",
          py: 8,
          color: "#fff",
        }}
      >
        <Box
          sx={{
            maxWidth: "1200px",
            mx: "auto",
            textAlign: "center",
            px: 2,
          }}
        >
          {/* Heading */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              letterSpacing: "1px",
              mb: 1,
            }}
          >
            NEIGHBOURHOOD EDUCATIONAL INSTITUTES
          </Typography>

          {/* Subheading */}
          <Typography
            variant="body1"
            sx={{
              color: "#ccc",
              fontSize: "18px",
              mb: 5,
            }}
          >
            Leading Educational Institutes Near To Our Project Location
          </Typography>

          {/* Hospital Logos */}
          <Grid
            container
            spacing={4}
            justifyContent="center"
            alignItems="center"
          >
            {EducationLogos.map((hospital) => (
              <Grid
                item
                key={hospital.id}
                xs={6}
                sm={4}
                md={2.4}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={hospital.image}
                  alt={hospital.name}
                  sx={{
                    width: "140px",
                    height: "auto",
                    borderRadius: "10px",
                    backgroundColor: "#fff",
                    p: 2,
                    boxShadow: "0 4px 15px rgba(255,255,255,0.1)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                      boxShadow: "0 6px 25px rgba(255,255,255,0.3)",
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: "#f8f8f8",
          py: 5,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* Map Box */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1400px",
            height: { xs: "350px", sm: "450px", md: "500px" },
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
          }}
        >
          <iframe
            title="KIADB Industrial Area Location"
            src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d26015.053313847988!2d77.74275!3d13.222083!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDEzJzE5LjUiTiA3N8KwNDQnMzMuOSJF!5e1!3m2!1sen!2sus!4v1761730877631!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>
      </Box>

      {/* Call to Action */}
      <Box
        sx={{
          background:
            "linear-gradient(to right, rgba(226, 255, 255, 0.26), rgba(0, 180, 194, 0.16))",
          color: "#fff",
          py: 4,
          textAlign: "center",
        }}
      >
        <Container>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item xs={12} md={6} sx={{ mb: { xs: 3, md: 0 } }}>
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, color: "#018f87" }}
              >
                Ready to start your wellness journey?
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" },
                }}
              >
                <Button
                  variant="contained"
                  size="medium"
                  sx={{
                    backgroundColor: "#018f87",
                    "&:hover": { backgroundColor: "#11b9a0ff" },
                    px: 4,
                    py: 1,
                    fontSize: "1rem",
                    fontWeight: 600,
                    mr: 2,
                  }}
                >
                  Book Consultation
                </Button>
                <Button
                  variant="outlined"
                  size="medium"
                  sx={{
                    borderColor: "#b5651d",
                    color: "#018f87",
                    px: 4,
                    py: 1,
                    fontSize: "1rem",
                    fontWeight: 600,
                  }}
                >
                  Call Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default NeighbourhoodEducation;
